document.addEventListener('DOMContentLoaded', function() {

  // Create and style the 'hulk-big-image' div
  const bigImageDiv = document.createElement('div');
  bigImageDiv.className = 'hulk-big-image';
  document.body.appendChild(bigImageDiv);

  // Style for 'hulk-big-image'
  const style = document.createElement('style');
  style.textContent = `
    .hulk-big-image {
    position: fixed;
      display: none;
      top: 25%;
      left: 1%;
      width: calc(100% - 50.5%);
      height: auto;
      background: transparent;
      overflow: hidden;
      z-index: 1000;
    }
    .hulk-big-image img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  `;
  document.head.appendChild(style);

  // Function to update or create inputs for each dropdown's selected variant
  function updateVariantData() {
    const dropdowns = document.querySelectorAll('.custom-dropdown');
    const variantDataDiv = document.querySelector('.variant_data');

    // Clear existing inputs to prevent duplication
    variantDataDiv.innerHTML = '';

    dropdowns.forEach(function(dropdown, index) {
      const variantId = dropdown.getAttribute('data-selected-id');
      const variantTitle = dropdown.getAttribute('data-selected-title');
      const variantPrice = dropdown.getAttribute('data-selected-price');

      if (variantId) {
        // Create and append hidden inputs for each dropdown's selected variant
        const inputId = document.createElement('input');
        inputId.type = 'hidden';
        inputId.name = `properties[id_${index}]`;
        inputId.value = variantId;

        const inputTitle = document.createElement('input');
        inputTitle.type = 'hidden';
        inputTitle.name = `properties[Title_${index}]`;
        inputTitle.value = variantTitle;

        const inputPrice = document.createElement('input');
        inputPrice.type = 'hidden';
        inputPrice.name = `properties[Price_${index}]`;
        inputPrice.value = variantPrice == "" ? market_currency_symbol + "0" : variantPrice;
        // inputPrice.value = variantPrice;

        variantDataDiv.appendChild(inputId);
        variantDataDiv.appendChild(inputTitle);
        variantDataDiv.appendChild(inputPrice);
      }
    });
  }

  // Handle dropdown interactions
  const dropdowns = document.querySelectorAll('.custom-dropdown');

  dropdowns.forEach(function(dropdown) {
    const selected = dropdown.querySelector('.dropdown-selected');
    const optionsList = dropdown.querySelector('.dropdown-options');
    const optionItems = optionsList.querySelectorAll('li');

    // Toggle dropdown visibility
    selected.addEventListener('click', function() {
      optionsList.classList.toggle('show');
    });

    // Handle option selection
    optionItems.forEach(function(option) {
      option.addEventListener('click', function() {
        const selectedText = this.querySelector('.variant-title').innerText;
        const imageUrl = this.querySelector('.variant-image img').src;
        const variantId = this.getAttribute('data-id');
        const variantPrice = this.getAttribute('data-price');

        // Update selected text and image in the dropdown
        selected.querySelector('.selected-title').innerText = selectedText;
        selected.querySelector('.selected-image').innerHTML = '<img src="' + imageUrl + '" alt="Variant Image">';

        // Store selected variant data in attributes
        dropdown.setAttribute('data-selected-id', variantId);
        dropdown.setAttribute('data-selected-title', selectedText);
        dropdown.setAttribute('data-selected-price', variantPrice);
        dropdown.setAttribute('data-selected-image', imageUrl);

        // Update the hidden inputs for all dropdowns
        updateVariantData();

        // Highlight the selected item
        optionItems.forEach(function(item) {
          item.classList.remove('selected');
        });
        this.classList.add('selected');

        optionsList.classList.remove('show');
      });

      // Show large image on hover
      option.addEventListener('mouseover', function() {
        const imageUrl = this.querySelector('.variant-image img').src;
        bigImageDiv.innerHTML = '<img src="' + imageUrl + '" alt="Large Variant Image">';
        bigImageDiv.style.display = 'block';
      });

      option.addEventListener('mouseout', function() {
        bigImageDiv.style.display = 'none';
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.custom-dropdown')) {
        optionsList.classList.remove('show');
      }
    });
  });
  
  // Validate if all required product variants are selected
  function validateSelection() {
    let allValid = true;
    const requiredDropdowns = document.querySelectorAll('.related-product.required_product');

    requiredDropdowns.forEach(function(requiredDropdown) {
      const selectedTitle = requiredDropdown.querySelector('.selected-title').textContent.trim();
      if (selectedTitle === '-' || selectedTitle === '') {
        requiredDropdown.classList.add('select_product');
        allValid = false;
      } else {
        requiredDropdown.classList.remove('select_product');
      }
    });

    // const swatches_wrapper = document.querySelector('.related-product.json_data_info');
    // const element = document.querySelector('.selected-title_sec');
    // if (element && element.textContent.trim() === '-') {
    //      allValid = false;

    //     // Apply styling if no option is selected
    //     swatches_wrapper.style.background = '#fff';
    //     swatches_wrapper.style.padding = '8px';
    //     swatches_wrapper.style.borderRadius = '6px';
    //     swatches_wrapper.style.border = '1px solid #242222';
    //   } 

    return allValid;
  }

  // Attach event listener to Add to Cart buttons
  const addToCartButtons = document.querySelectorAll('.custom-main-product .cart-functions .buttons-holder button.product__add-to-cart');
  
  addToCartButtons.forEach(function(addToCartButton) {
    addToCartButton.addEventListener('click', function(event) {
      if (!validateSelection()) {
        event.preventDefault();
      }
    });
  });

  // Automatically update hidden fields for selected variant and remove 'select_product' class
  document.querySelectorAll('.dropdown-options li').forEach(function(option) {
    //debugger;
    option.addEventListener('click', function() {
      const variantId = option.getAttribute('data-id');
      const variantTitle = option.querySelector('.variant-title').textContent;
      const variantPrice = option.getAttribute('data-price');
      
      document.getElementById('variant-id').value = variantId;
      document.getElementById('variant-title').value = variantTitle;
      document.getElementById('variant-price').value = variantPrice;
      
      const requiredDropdown = option.closest('.dropdown-selected.required_product');
      if (requiredDropdown) {
        requiredDropdown.classList.remove('select_product');
      }
    });
  });
});

window.customProductInstance = new CustomProduct();